import { ref, watch } from '@vue/composition-api'
// import store from '@/store'

export default function useTaskHandler(props, emit) {
  // ------------------------------------------------
  // taskLocal
  // ------------------------------------------------
  const taskLocal = ref(JSON.parse(JSON.stringify(props.task.value)))
  const comment = ref(null)
  const checkProgress = ref(props.onProgress.value)

  const attachment = ref({
    items: [
      {
        id: 1,
        file: null,
      },
    ],
    nextItemId: 2,
  })

  const commentAttachment = ref({
    items: [
      {
        id: 1,
        file: null,
      },
    ],
    nextItemId: 2,
  })

  const resetTaskLocal = () => {
    taskLocal.value = JSON.parse(JSON.stringify(props.task.value))
    checkProgress.value = false
    attachment.value = {
      items: [
        {
          id: 1,
          file: null,
        },
      ],
      nextItemId: 2,
    }
    comment.value = null

  }
  watch(props.task, () => {
    resetTaskLocal()
  })

  watch(props.onProgress, () => {
    if (props.onProgress.value === false) {
      checkProgress.value = false
    }
  })

  const onSubmit = () => {
    checkProgress.value = true

    const taskData = JSON.parse(JSON.stringify(taskLocal))

    const data = taskData.value

    const taskFormData = new FormData()
    taskFormData.append('title', data.title)
    taskFormData.append('description', data.description)
    taskFormData.append('assigned_to', typeof data.assignee === 'object' && data.assignee !== null ? data.assignee.id : data.assignee)
    taskFormData.append('priority', typeof data.priority === 'object' && data.priority !== null ? data.priority.key : data.priority)
    if (typeof data.project === 'object' && data.project !== null) {
      taskFormData.append('project_id', data.project.id)
    } else if (typeof data.project === 'number') {
      taskFormData.append('project_id', data.project)

    }

    taskFormData.append('due_date', data.dueDate)
    data.tags.map(tag => {
      taskFormData.append('tags[]', tag)
    })
    attachment.value.items.map(attachment => {
      taskFormData.append('attachments[]', attachment.file)
    })

    if (props.task.value.id) {
      emit('update-task', {
        id: props.task.value.id,
        data: taskFormData
      })
    } else {
      emit('add-task', taskFormData)
    }

    // Close sidebar
    // emit('update:is-task-handler-sidebar-active', false)
  }
  const onSubmitComment = () => {
    checkProgress.value = true

    const commentFormData = new FormData()
    commentFormData.append('comment', comment.value)
    commentFormData.append('id', props.task.value.id)
    commentAttachment.value.items.map(attachment => {
      commentFormData.append('attachments[]', attachment.file)
    })

    if (props.task.value.id) {
      emit('send-comment', {
        id: props.task.value.id,
        data: commentFormData
      })
    }

    // Close sidebar
    // emit('update:is-task-handler-sidebar-active', false)
  }

  const updateImportant = () => {
    const data = {
      'id': props.task.value.id,
    }
    if (props.task.value.id) emit('update-important', data)
    emit('update:is-task-handler-sidebar-active', false)

  }
  const completeTask = () => {
    const data = {
      'id': props.task.value.id,
    }
    if (props.task.value.id) emit('complete-task', data)
    emit('update:is-task-handler-sidebar-active', false)

  }

  const repeatAgain = () => {
    attachment.value.nextItemId++
    attachment.value.items.push({
      id: attachment.value.nextItemId,
      file: null,
    })
  }
  const removeItem = (index) => {
    attachment.value.items.splice(index, 1)
  }

  const repeatAgainCommentAttach = () => {
    commentAttachment.value.nextItemId++
    commentAttachment.value.items.push({
      id: commentAttachment.value.nextItemId,
      file: null,
    })
  }
  const removeCommentAttachItem = (index) => {
    commentAttachment.value.items.splice(index, 1)
  }

  return {
    taskLocal,
    resetTaskLocal,
    checkProgress,
    // UI
    onSubmit,
    onSubmitComment,
    removeItem,
    repeatAgain,
    attachment,
    comment,
    updateImportant,
    completeTask,
    commentAttachment,
    removeCommentAttachItem,
    repeatAgainCommentAttach,
  }
}
